<form [formGroup]="productForm" class="product-form">
  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field full-width">
      <mat-label>Member-facing display name</mat-label>
      <input matInput formControlName="displayName" placeholder="e.g. CuraLinc EAP" />
      <mat-hint>Optional. Leave blank to keep current member-facing naming. Internal product names remain unchanged.</mat-hint>
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Vendor Name</mat-label>
      <input matInput formControlName="vendorName" placeholder="Enter vendor name" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Product Name</mat-label>
      <input matInput formControlName="productName" placeholder="Enter product name" />
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Vendor Slug</mat-label>
      <input matInput formControlName="vendorSlug" placeholder="Enter vendor slug" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Product Slug</mat-label>
      <input matInput formControlName="productSlug" placeholder="Enter product slug" />
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Stripe Product ID</mat-label>
      <input matInput formControlName="stripeProductId" placeholder="Enter Stripe product ID" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Stripe Vendor</mat-label>
      <input matInput formControlName="stripeVendor" placeholder="Enter Stripe vendor" />
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field full-width">
      <mat-label>Metadata (JSON)</mat-label>
      <textarea
        matInput
        formControlName="metadata"
        placeholder='Enter metadata as JSON (e.g., {"key": "value"})'
        rows="6"
        (blur)="formatJsonOnBlur('metadata')"
      ></textarea>
      <mat-hint>
        Payroll Admin display overrides: <code>payrollAdminVendorName</code> and
        <code>payrollAdminProductName</code> and <code>payrollAdminDetailsUrl</code> and
        <code>payrollAdminLogoUrl</code>
      </mat-hint>
      @if (productForm.get('metadata')?.hasError('invalidJson') || productForm.get('metadata')?.hasError('invalidMetadata')) {
        <mat-error>
          Metadata must be a JSON object
        </mat-error>
      }
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field full-width">
      <mat-label>Feed Config (JSON)</mat-label>
      <textarea
        matInput
        formControlName="feedConfig"
        placeholder='Enter feed config as JSON (e.g., {"key": "value"})'
        rows="6"
        (blur)="formatJsonOnBlur('feedConfig')"
      ></textarea>
      @if (productForm.get('feedConfig')?.hasError('invalidJson')) {
        <mat-error>
          Invalid JSON format
        </mat-error>
      }
    </mat-form-field>
  </div>

  <div class="form-actions">
    <button
      mat-raised-button
      color="primary"
      (click)="saveProduct()"
      [disabled]="!productForm.valid"
      >
      Save Product
    </button>
    <button mat-button type="button" (click)="resetForm()">Reset</button>
  </div>
</form>
